import {toDecimalString as tds} from '@/utils/number'

export const toDecimalString = (value, n) => {
	return tds(value, n)
}